module.exports = __webpack_public_path__ + "img/lrb_logo.7c164c86.png";